import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { getCityFullName } from '@/utils/area'

Vue.config.productionTip = false

Vue.use(ElementUI)

// 全局挂载进件城市展示方法，供各页面模板直接使用（Vue2模板中的函数需挂载在实例上）
Vue.prototype.getCityFullName = getCityFullName

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
